import instance from "../utils/instance";

class BudgetService {
    async getExpense(projectId) {
        return await instance.get('/crm/budget/getBudgetExpense?projectId=' + projectId + '&checkCost=true');
    }
}

export default new BudgetService();